import { makeEntityScaffold } from '@classpass/saga-tools';
import { DALNotFoundError } from '@classpass/dal';
export var friendbuy = makeEntityScaffold('SAGA.API.FRIENDBUY', function (client, referralCode) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.friendbuy.getReferral(referralCode, options).catch(function (err) {
    // 404s just mean that code is invalid
    if (err instanceof DALNotFoundError) {
      return false;
    }

    throw err;
  });
}, {
  defaultKey: 1
});